<template>
  <div>
    <menu-pae />

    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item"><router-link to="/workArea">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/legado">Legado</router-link></li>
              <li class="breadcrumb-item"> {{ protocolo ? formatarProtocolo(protocolo.numeroProtocoloFormatado) : '' }} </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>

    <div class="container-md">
      <div class="m-2 col-12 row btnAcoes" v-if="hasProtocolo ? !isImportado() && (protocolo.anexo === '000000000000' || !this.protocolo.anexo) : false">
        <importacaoStatus v-if="importacao" :key="importacaoKey"/>
        <button v-if="(!importacao || params.erro) && !isPodeImportarEditar()" class="btn btn-outline-primary" @click.prevent="$refs.confirmacaoAtribuir.openModal()"> Atribuir </button>
      </div>
      <div class="card" v-if="hasProtocolo">
        <div class="card-header link" @click="selected = 'Informações Gerais'" style="background-color: #e2edfc; color: #4a75b5">
          <div class="row">
            <div class="col-6"><h5>Informações Gerais</h5></div>
            <div class="col-6 text-right">
              <i
                v-if="protocolo.arquivamento && !isPodeImportarEditar()"
                @click="habilitaCamposDeEdicao()"
                class="fa fa-pencil fa-1-5x m-1"
                aria-hidden="true"
              ></i>
            </div>
          </div>
        </div>
        <div class="card-body" v-if="selected === 'Informações Gerais' && hasProtocolo">
          <div class="row" v-if="isViewing">
            <div class="col-sm-8">
              <p class="m-0">Protocolo: <strong>{{ hasProtocolo ? formatarProtocolo(protocolo.numeroProtocoloFormatado) : '' }}</strong> </p>
              <p class="m-0">Tipo Protocolo: {{
                (protocolo.anoAntigo === '0000' || protocolo.anoAntigo === undefined || protocolo.anoAntigo === '') ? 'Documento' : 'Processo'
              }} </p>
              <p class="m-0">Sigiloso: {{ protocolo.sigiloso ? 'Sim' : 'Não' }} </p>
              <p class="m-0">Origem: {{ protocolo.origem }} </p>
              <p class="m-0">Município: {{ `${protocolo.cidade} - ${protocolo.estado}` }} </p>
              <p class="m-0">Assunto: {{ protocolo.assunto ? protocolo.assunto.descricao : '' }} </p>
              <p class="m-0">Detalhamento: {{ protocolo.detalhamento ? protocolo.detalhamento : protocolo.arquivamento ? protocolo.arquivamento.detalhamento : '' }} </p>
            </div>
            <div class="col-sm-4">
              <p class="m-0">Data Abertura: {{ formatarDate(protocolo.dataCadastro || protocolo.arquivamento.dataAbertura) }} </p>
              <p class="m-0" v-if="protocolo.anexo">Apensado em: {{ formatarProtocoloSPI(protocolo.anexo) }} </p>
            </div>
            <hr class="bg-muted col-10">
            <div class="col-sm-8">
              <p class="m-0">Usuário Criação: {{
                protocolo.userCadastro ? protocolo.userCadastro.nome : protocolo.localDe ? protocolo.localDe.nomeResponsavel : ''
              }} </p>
            </div>
            <div class="col-sm-4">
              <p class="m-0">Data da Criação: {{ formatarDate(protocolo.dataCadastro || protocolo.arquivamento.dataAbertura) }} </p>
            </div>
            <hr class="bg-muted col-10">
            <div class="col-12">
              <strong>Interessados</strong>
              <div v-for="interessado in interessados" :key="interessado.rg" class="row">
                <div class="col-2 text-center">Tipo: {{ interessado.tipo }}</div>
                <div class="col-6 text-center">Nome: {{ interessado.nome }}</div>
                <div class="col-4 text-center">Num. Documento: {{ interessado.rg }}</div>
              </div>
            </div>
          </div>
          <div class="row" v-if="!isViewing">
            <div class="col-sm-8">
              <p class="m-0">Protocolo: <strong>{{ hasProtocolo ? formatarProtocolo(protocolo.numeroProtocoloFormatado) : '' }}</strong> </p>
              <p class="m-0">Tipo Protocolo: {{
                (protocolo.anoAntigo === '0000' || protocolo.anoAntigo === undefined || protocolo.anoAntigo === '') ? 'Documento' : 'Processo'
              }} </p>
              <p class="m-0">Sigiloso: {{ protocolo.sigiloso ? 'Sim' : 'Não' }} </p>

              <p class="m-0" v-if="protocolo.origem">Origem: {{ protocolo.origem }} </p>
              <div class="m-0 mb-2" v-if="!protocolo.origem">Origem: <input type="text" class="form-control" v-model="protocoloAlterado.origem"></div>

              <p class="m-0" v-if="protocolo.cidade">Município: {{ `${protocolo.cidade} - ${protocolo.estado}` }} </p>
              <div class="m-0 mb-2" v-if="!protocolo.cidade">Município: <input type="text" class="form-control" v-model="protocoloAlterado.cidade"></div>
              <div class="m-0 mb-2" v-if="!protocolo.cidade">Estado: <input type="text" class="form-control" v-model="protocoloAlterado.estado"></div>

              <p class="m-0" v-if="protocolo.assunto">Assunto: {{ protocolo.assunto ? protocolo.assunto.descricao : '' }} </p>
              <div class="m-0 mb-2" v-if="!protocolo.assunto">
                Assunto:
                <auto-complete-comp
                  :isAsync="true"
                  :url="urlDadosFixosAssunto"
                  :marginTop="10"
                  mutation="MUT_ASSUNTO"
                  keyAttrName="id"
                  valueAttrName="descricao"
                  keyAttrFilter="descricao"
                  :valor="protocolo.assunto"
                  css="form__input autocomplete w-100"
                  :params="autoCompleteParams"
                >
                </auto-complete-comp>
              </div>

              <p class="m-0" v-if="protocolo.detalhamento || protocolo.arquivamento.detalhamento">Detalhamento: {{ protocolo.detalhamento || protocolo.arquivamento.detalhamento }} </p>
            </div>
            <div class="col-sm-4">
              <p class="m-0" v-if="protocolo.dataCadastro || protocolo.arquivamento.dataAbertura">Data Abertura: {{ formatarDate(protocolo.dataCadastro || protocolo.arquivamento.dataAbertura) }} </p>
              <div class="m-0 mb-2" v-if="!protocolo.dataCadastro && !protocolo.arquivamento.dataAbertura">
                Data Abertura: <input class="form-control" type="datetime-local" v-model="protocoloAlterado.dataCadastro">
              </div>
              <p class="m-0" v-if="protocolo.anexo">Apensado em: {{ formatarProtocoloSPI(protocolo.anexo) }} </p>
            </div>
            <div class="col-12" v-if="!protocolo.detalhamento && !protocolo.arquivamento.detalhamento">
              <div class="m-0 mb-2">
                Detalhamento:
                <textarea name="detalhamento" id="detalhamento" rows="3" maxlength="300" class="form-control" v-model="protocoloAlterado.detalhamento"></textarea>
              </div>
            </div>
            <hr class="bg-muted col-10">
            <div class="col-sm-8">
              <p class="m-0" v-if="protocolo.userCadastro || protocolo.localDe">Usuário Criação: {{
                protocolo.userCadastro ? protocolo.userCadastro.nome : protocolo.localDe ? protocolo.localDe.nomeResponsavel : ''
              }} </p>
            </div>
            <div class="col-sm-4">
              <p class="m-0" v-if="protocolo.dataCadastro || protocolo.arquivamento.detalhamento">Data da Criação: {{ formatarDate(protocolo.dataCadastro || protocolo.arquivamento.dataAbertura) }} </p>
            </div>
            <hr class="bg-muted col-10">
            <div class="col-12">
              <strong>Interessados</strong>
              <div class="row mb-2">
                <div class="col-2">
                  Tipo <input type="text" class="form-control" v-model="interessado.tipo">
                </div>
                <div class="col-6">
                  Nome <input type="text" class="form-control" v-model="interessado.nome">
                </div>
                <div class="col-3">
                  Num. Documento <input type="number" class="form-control" v-model="interessado.rg">
                </div>
                <div class="col-1 d-flex justify-content-center align-items-end">
                  <button type="button" class="btn btn-outline-success" @click="adicionar()">Adicionar</button>
                </div>
              </div>
              <div v-for="interessado in interessados" :key="interessado.rg" class="row">
                <div class="col-2 text-center">Tipo: {{ interessado.tipo }}</div>
                <div class="col-6 text-center">Nome: {{ interessado.nome }}</div>
                <div class="col-3 text-center">Num. Documento: {{ interessado.rg }}</div>
              </div>
              <div v-for="(interessado, index) in protocoloAlterado.interessados" :key="interessado.rg" class="row">
                <div class="col-2 text-center">Tipo: {{ interessado.tipo }}</div>
                <div class="col-6 text-center">Nome: {{ interessado.nome }}</div>
                <div class="col-3 text-center">Num. Documento: {{ interessado.rg }}</div>
                <div class="col-1 text-danger"><i class="fa fa-trash-o fa-1-5x link" aria-hidden="true" @click="remover(index)"></i></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card" v-if="hasProtocolo">
        <div class="card-header link" @click="selected = 'Andamento Atual'" style="background-color: #e2edfc; color: #4a75b5">
          <div class="row">
            <div class="col-6"><h5>Andamento Atual</h5></div>
          </div>
        </div>
        <div class="card-body" v-if="selected === 'Andamento Atual'">
          <div class="row">
            <div class="col-8">
              <p class="m-0">Origem: {{ protocolo.localDe ? `${protocolo.localDe.codigo} - ${protocolo.localDe.nome}`: '' }} </p>
              <p class="m-0">Usuário  Envio: {{ protocolo.cadastro ? protocolo.cadastro.userIdDe : '' }} </p>
            </div>
            <div class="col-4">
              <p class="m-0">Data Envio: {{ formatarDate(protocolo.dataEnvio) }} </p>
              <p class="m-0">Telefone Envio: {{ protocolo.localDe ? formatarTelefone(protocolo.localDe.telefone): '' }} </p>
            </div>

            <hr class="bg-muted col-10" v-if="protocolo.localPara !== undefined">

            <div class="col-8">
              <p class="m-0">Destino: {{ protocolo.localPara ? `${protocolo.localPara.codigo} - ${protocolo.localPara.nome}`: '' }} </p>
              <p class="m-0">Usuário Recebimento: {{ protocolo.cadastro ? protocolo.cadastro.userIdPara : '' }} </p>
            </div>
            <div class="col-4">
              <p class="m-0" v-if="protocolo.dataRecebimento !== undefined">Data Recebimento: {{ formatarDate(protocolo.dataRecebimento) }} </p>
              <p class="m-0">Telefone Destino: {{ protocolo.localPara ? formatarTelefone(protocolo.localPara.telefone): '' }} </p>
            </div>

            <div class="col-12">
              <p class="m-0">Situação: {{ protocolo.arquivamento ? 'Arquivado' : protocolo.situacao === 'E' ? 'Em Andamento' : 'Recebido' }} </p>
            </div>

            <hr class="bg-muted col-10" v-if="protocolo.userConclusao !== undefined">

            <div class="col-8" v-if="protocolo.userConclusao !== undefined">
              <p class="m-0">Usuário de Conclusão: {{ protocolo.userConclusao ? protocolo.userConclusao.nome : '' }} </p>
            </div>
            <div class="col-4" v-if="protocolo.userConclusao !== undefined">
              <p class="m-0">Conclusão: {{ formatarDate(protocolo.dataConclusao) }} </p>
              <p class="m-0">Data de Conclusão: {{ formatarDate(protocolo.dataConclusao) }} </p>
            </div>

            <hr class="bg-muted col-10" v-if="protocolo.arquivamento !== undefined">

            <div class="col-8" v-if="protocolo.arquivamento !== undefined">
              <p class="m-0">Número Caixa: {{ protocolo.arquivamento.numeroCaixa }} </p>
            </div>
            <div class="col-4" v-if="protocolo.arquivamento !== undefined">
              <p class="m-0">Data do Arquivamento: {{ formatarDate(protocolo.arquivamento.dataArquivo) }} </p>
            </div>
          </div>
        </div>
      </div>

      <div class="card" v-if="hasProtocolo">
        <div class="card-header link" @click="selected = 'Historico de Tramitação'" style="background-color: #e2edfc; color: #4a75b5">
          <div class="row">
            <div class="col-6"><h5>Histórico de Tramitação</h5></div>
          </div>
        </div>
        <div class="card-body" v-if="selected === 'Historico de Tramitação'">
          <div class="row" v-for="tramitacao in tramitacoes.data" :key="tramitacao.icon">
            <div class="col-6">
              <p class="m-0">Origem: {{ tramitacao.localDe ? tramitacao.localDe.nome || '': '' }} </p>
              <p class="m-0">Data Envio: {{ configDateString(tramitacao.dataEnvio) }} </p>
              <p class="m-0">Usuário Envio: {{ tramitacao.userIdDe }} </p>
              <p class="m-0">Motivo Tramitação: {{ tramitacao.motivo.descricao || '' }} </p>
              <p class="m-0">Situação: {{ tramitacao.situacao === 'E' ? 'Enviado' : 'Recebido' }} </p>
            </div>
            <div class="col-6">
              <p class="m-0">Destino: {{ tramitacao.localPara ? tramitacao.localPara.nome || '' : '' }} </p>
              <p class="m-0">Data Recebimento: {{ configDateString(tramitacao.dataRecebimento) }} </p>
              <p class="m-0">Usuário Recebimento: {{ tramitacao.userIdPara }} </p>
            </div>
            <hr class="bg-muted col-10">
          </div>
          <div class="mt-2">
            <pagination-comp :pagination="tramitacoes.pagination" :eventBusDataPaginationName="eventPagination"/>
          </div>
        </div>
      </div>

      <div class="card" v-if="isImportado()">
        <div class="card-header link" @click="selected = 'Historico de Importação'" style="background-color: #e2edfc; color: #4a75b5">
          <div class="row">
            <div class="col-6"><h5>Historico de Importação</h5></div>
          </div>
        </div>
        <div class="card-body" v-if="selected === 'Historico de Importação'">
          <div class="col-12">
            <p class="m-0">Data Importação: {{ importado.dataImportacao }} </p>
            <p class="m-0">Responsável: {{ importado.responsavelImportacao.titulo }} </p>
            <p class="m-0">Local: {{
              importado.responsavelImportacao.participantePai.participantePai.titulo + ' - ' + importado.responsavelImportacao.participantePai.titulo
            }} </p>
            <p class="m-0">Local Sigla: {{
              importado.responsavelImportacao.participantePai.participantePai.subtitulo + ' - ' + importado.responsavelImportacao.participantePai.subtitulo
            }} </p>
          </div>
          <hr class="bg-muted col-10">
        </div>
      </div>
    </div>

    <modal ref="confirmacaoAtribuir" width="500px" height="" v-if="hasProtocolo">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="text-primary m-3">Realmente deseja importar e atribuir a si, o protocolo {{ protocolo.numeroProtocoloFormatado || '' }}?</h4>
          <i class="fa fa-times fa-1-5x m-2 link" @click="$refs.confirmacaoAtribuir.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body text-md-right text-sm-center">
          <button type="button" class="btn btn-outline-primary m-1" @click.prevent="importar(protocolo.numeroProtocolo)">Confirmar</button>
        </div>
      </template>
    </modal>

    <modal ref="informacaoAdicional" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="text-primary m-3">IMPORTANTE</h4>
          <i class="fa fa-times fa-1-5x m-2 link" @click="$refs.informacaoAdicional.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body text-md-center text-sm-center">
          <div>
            Os dados visualizados abaixo serão os importados,
             caso haja campos em branco,
             favor clicar no botão editar <i class="fa fa-pencil fa-1-5x m-1" aria-hidden="true"></i> para fazer o preenchimento dos dados.
             Após a importação, os documentos avulsos e processos deverão ser obrigatoriamente regularizados.
          </div>
          <button type="button" class="btn btn-outline-primary mt-2" @click="$refs.informacaoAdicional.closeModal()">Confirmar</button>
        </div>
      </template>
    </modal>

    <modal ref="protocolosArquivados" width="500px" height="">
        <template v-slot:header>
          <div class="modal-header">
            <h4 class="text-primary m-3">ATENÇÃO</h4>
            <i class="fa fa-times fa-1-5x m-2 link" @click="$refs.protocolosArquivados.closeModal()" />
          </div>
        </template>
        <template v-slot:body>
          <div class="modal-body text-md-center text-sm-center">
            <div>
              Os Protocolos arquivados só podem ser importados e editados por usuários
              que possuem o perfil "Unidade_Protocolo_ Arquivo".
            </div>
            <button type="button" class="btn btn-outline-primary mt-2" @click="$refs.protocolosArquivados.closeModal()">Confirmar</button>
          </div>
      </template>
    </modal>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import modal from '@/components/shared/Modal.vue'
import importacaoStatus from '@/components/notification/custom/importacaoStatus'
import paginationComp from '@/components/pagination/PaginationComp'
import autoCompleteComp from '@/components/autocomplete/AutoCompleteComp'

import { protocoloParse, protocoloSpiParse, telefoneParse } from '@/uteis/converters/ProtocoloConverter'
import { localDatetimeParse, configDate } from '@/uteis/converters/LocalDateConverter'

import DataValues from '@/components/data-table-consulta/DataValues'
import eventBus from '@/uteis/eventBus'
import { mapState } from 'vuex'

import ProcessoElaboracaoService from '@/services/ProcessoElaboracaoService'
import { componentIsVisible, rules } from '@/uteis/action/permissao'

export default {
  name: 'legado',
  components: {
    menuPae,
    modal,
    paginationComp,
    importacaoStatus,
    autoCompleteComp
  },

  created () {
    this.service = new ProcessoElaboracaoService()

    this.numeroProtocolo = this.$route.params.numeroProtocolo

    this.pesquisar()

    this.isPodeImportarEditar()
    eventBus.$on(this.eventPagination, (page) => {
      this.page = page
    })
  },

  computed: {
    ...mapState({
      params: state => state.notification.params
    }),

    interessados () {
      if (!this.protocolo) {
        return []
      }

      if (!this.protocolo.arquivamento) {
        return this.protocolo.interessados
      }

      var interessadosArquivados = []

      if (this.protocolo.arquivamento.nomeInteressado && this.protocolo.arquivamento.nomeInteressado !== '') {
        interessadosArquivados.push({
          tipo: this.protocolo.arquivamento.tipoInteressado,
          nome: this.protocolo.arquivamento.nomeInteressado,
          rg: this.protocolo.arquivamento.rgInteressado1
        })
      }

      if (this.protocolo.arquivamento.nomeInteressado2 && this.protocolo.arquivamento.nomeInteressado2 !== '') {
        interessadosArquivados.push({
          tipo: this.protocolo.arquivamento.tipoInteressado2,
          nome: this.protocolo.arquivamento.nomeInteressado2,
          rg: this.protocolo.arquivamento.rgInteressado2
        })
      }

      return interessadosArquivados
    },

    tramitacoes () {
      if (!this.protocolo) {
        return { data: [], pagination: {} }
      }

      var tramitacoes = this.protocolo.tramitacoes

      if (!tramitacoes) {
        return { data: [], pagination: {} }
      }

      tramitacoes.sort(function (a, b) {
        if (a.dataEnvio > b.dataEnvio) {
          return -1
        }

        if (a.dataEnvio < b.dataEnvio) {
          return 1
        }

        if (a.dataRecebimento > b.dataRecebimento) {
          return -1
        }

        if (a.dataRecebimento < b.dataRecebimento) {
          return 1
        }

        return 0
      })

      const dataValues = new DataValues(this.protocolo.tramitacoes, this.page, this.perPage)
      return dataValues
    },

    importado () {
      var tenant = this.tenant
      var importacoes = this.protocolo.importacao

      for (var importacao of importacoes) {
        if (importacao.tenant === tenant) {
          return importacao
        }
      }

      return {}
    }
  },

  data () {
    return {
      selected: 'Informações Gerais',
      protocolo: {},
      hasProtocolo: false,
      tenant: undefined,
      perPage: 10,
      page: 1,
      eventPagination: 'tramitacoesPagination',
      importacao: false,
      importacaoKey: false,
      isViewing: true,
      urlDadosFixosAssunto: '/d0593/pae-back/v1/spi/assuntos',
      autoCompleteParams: {},
      interessado: {
        tipo: '',
        nome: '',
        rg: ''
      },
      protocoloAlterado: {
        assunto: {},
        origem: '',
        cidade: '',
        estado: '',
        detalhamento: '',
        dataCadastro: '',
        userCadastro: {
          nome: '',
          matricula: '',
          orgao: '',
          telefone: ''
        },
        interessados: []
      },
      podeImportarEditar: true,
      importacaoPorcentagem: '0%'
    }
  },

  methods: {
    formatarProtocolo: (protocolo) => protocoloParse(protocolo).value,
    formatarProtocoloSPI: (protocolo) => protocoloSpiParse(protocolo).value,
    formatarTelefone: (telefone) => telefoneParse(telefone).value,
    formatarDate: (date) => localDatetimeParse(date).value,
    configDateString: (date) => configDate(date).value,

    adicionar () {
      const interessado = this.interessado
      if (interessado.tipo === '' || interessado.nome === '' || interessado.rg === '') {
        return
      }
      this.protocoloAlterado.interessados.push(interessado)
      this.interessado = {
        tipo: '',
        nome: '',
        rg: ''
      }
    },

    remover (index) {
      this.protocoloAlterado.interessados.splice(index, 1)
    },

    pesquisar () {
      this.service.statusImportacao(this.numeroProtocolo).then((data) => {
        if (data && data.porcentagem) {
          this.importacaoPorcentagem = data.porcentagem
        }
      }).catch((err) => {
        console.log(err)
      })

      this.service.buscarProtocoloSPIPorNumeroProtocolo(this.numeroProtocolo).then(res => {
        this.hasProtocolo = true
        this.protocolo = res
        this.tenant = res.tenant

        if (this.protocolo.arquivamento) {
          this.$refs.protocolosArquivados.openModal()
          this.$refs.informacaoAdicional.openModal()
        }
      }).catch(err => {
        console.log(err)
      })
    },

    importar (numeroProtocolo) {
      // Validação de perfil para protocolos arquivados
      if (this.isPodeImportarEditar()) {
        this.$refs.protocolosArquivados.openModal()
        this.$refs.confirmacaoAtribuir.closeModal()
      } else {
        this.importacao = false
        this.importacaoKey = !this.importacaoKey
        var sessao = this.$store.getters.getDadosSessao.sessao

        var protocoloAlterado = {
          ...this.protocoloAlterado,
          assunto: this.$store.getters.getProcesso.assunto
        }
        if (this.protocoloAlterado.dataCadastro !== '') {
          protocoloAlterado.dataCadastro = new Date(this.protocoloAlterado.dataCadastro).getTime()
        }

        this.service.importarProtocoloSPI(numeroProtocolo, sessao, protocoloAlterado).then((data) => {
          this.$refs.confirmacaoAtribuir.closeModal()
          this.importacao = true
          this.$store.commit('MUT_NOTIFICATION', {
            alert: {
              type: 'light',
              texto: 'Começando a importação'
            },
            component: 'spi-importacao',
            params: {
              numeroProtocolo
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      }
    },

    isImportado () {
      var protocolo = this.protocolo
      if (!protocolo) {
        return false
      }

      var tenant = this.tenant
      var importacoes = protocolo.importacao

      if (!importacoes) {
        return false
      }

      for (var importacao of importacoes) {
        if (importacao.tenant === tenant && this.importacaoPorcentagem === '100%') {
          return true
        }
      }
      return false
    },

    validaPerfilUsuarioImportacao () {
      const { IMPORTAR_PROTOCOLO_ARQUIVADO_SPI } = rules
      return componentIsVisible(IMPORTAR_PROTOCOLO_ARQUIVADO_SPI)
    },

    isPodeImportarEditar () {
      if (this.protocolo.arquivamento && !this.validaPerfilUsuarioImportacao()) {
        this.podeImportarEditar = true
        return this.podeImportarEditar
      } else {
        this.podeImportarEditar = false
        return this.podeImportarEditar
      }
    },

    habilitaCamposDeEdicao () {
      if (this.isPodeImportarEditar()) {
        this.$refs.protocolosArquivados.openModal()
        this.$refs.confirmacaoAtribuir.closeModal()
        return
      }
      this.isViewing = false
    }
  }
}
</script>

<style lang="scss" scoped>
.acoes {
  display: flex;
  padding: 15px;
  position: absolute;

  .btn {
    margin-right: 10px;
    width: 150px;
    height: 28px;
  }
}
</style>
